import { render, staticRenderFns } from "./DirectOrderTab.vue?vue&type=template&id=514efa29&scoped=true"
import script from "./DirectOrderTab.vue?vue&type=script&lang=js"
export * from "./DirectOrderTab.vue?vue&type=script&lang=js"
import style0 from "./DirectOrderTab.vue?vue&type=style&index=0&id=514efa29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514efa29",
  null
  
)

export default component.exports